import { FC } from "react";

import { Box } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { AutomatedCommunicationCard } from ".././components/AutomatedCommunicationCard";
import { SendAutomatedEmailTestButton } from "../components/SendAutomatedEmailTestButton";
import { AutomatedCommunicationsFormData, RowKey } from "../types";

import { useTranslate } from "@/common/hooks/useTranslate";

interface ThankYouWinnerCardProps {
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  isSmsEnabled: boolean;
  defaultContent: string;
}

export const ThankYouWinnerCard: FC<ThankYouWinnerCardProps> = ({
  openRow,
  onToggleOpen,
  isSmsEnabled,
  defaultContent,
}) => {
  const { t } = useTranslate();
  const form = useFormContext<AutomatedCommunicationsFormData>();
  return (
    <AutomatedCommunicationCard<AutomatedCommunicationsFormData>
      label={t("dashboard", "ticketing.automatedCommunications.row.thankYouWinner.label")}
      control={form.control}
      errors={form.formState.errors}
      dataEmailType="thank-you-email"
      fields={{ subject: "thankYouWinner.subject", content: "thankYouWinner.content" }}
      enabled
      lockedOn
      toggleTooltip={t("dashboard", "ticketing.automatedCommunications.row.thankYouWinner.lockedTooltip")}
      chip={{
        label: t("dashboard", "ticketing.automatedCommunications.trigger.atAuctionClose"),
        showWhen: "enabled",
      }}
      collapse={{ isOpen: openRow === "thank-you-email", onToggle: () => onToggleOpen("thank-you-email") }}
      channelIcons={isSmsEnabled ? { email: true, sms: false } : undefined}
      body={{ defaultValue: defaultContent }}
      dataTestPrefix="thank-you-winner"
      footnote={
        <Box marginTop={2} display="flex" justifyContent="flex-start">
          <SendAutomatedEmailTestButton<AutomatedCommunicationsFormData>
            emailType="auction-thank-you-winner"
            subjectFieldName="thankYouWinner.subject"
            contentFieldName="thankYouWinner.content"
          />
        </Box>
      }
    />
  );
};
